import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';

@Component({
  selector: 'ppl-timepicker',
  standalone: true,
  imports: [ReactiveFormsModule, CalendarModule, FormsModule],
  templateUrl: './timepicker.component.html',
  styleUrl: './timepicker.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimepickerComponent),
      multi: true,
    },
  ],
})
export class TimepickerComponent implements ControlValueAccessor {
  @Input() placeholder = '';
  @Input() stepMinute = 1;
  @Input() id = '';
  @Input() ariaLabel = '';
  @Input() index: any;
  @Output() timeSelected = new EventEmitter<Date>();

  value: Date | null = null;
  ariaMessage = '';
  isDisabled = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    console.log('Setting value from form:', obj);
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onSelect(event: Date) {
    this.value = event;
    this.ariaMessage = `Time selected is ${event.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
    this.onChange(event);
    this.timeSelected.emit(event);
  }

  onTimeChange(value: Date | string): void {
    if (value instanceof Date && !isNaN(value.getTime())) {
      this.value = value;
      this.ariaMessage = `Time selected is ${value.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
      this.onChange(value);
      this.timeSelected.emit(value);
    } else {
      console.warn('Invalid or unparsed time input:', value);
    }
  }

  onCalendarShow() {
    setTimeout(() => {
      const timePickerPopup = this.doc.querySelector('.p-datepicker-timeonly');
      if (timePickerPopup) {
        this.renderer.setAttribute(
          timePickerPopup,
          'aria-label',
          'Choose Time'
        );
      }
      this.fixAmPmOnly();
    }, 0);
  }

  fixAmPmOnly(): void {
    setTimeout(() => {
      const pickers = this.doc.querySelectorAll('.p-ampm-picker');
      const picker = pickers.length
        ? (pickers[pickers.length - 1] as HTMLElement)
        : undefined;

      const amBtn =
        picker?.querySelector('button[aria-label="am"]') ??
        this.doc.querySelector('button[aria-label="am"]');

      const pmBtn =
        picker?.querySelector('button[aria-label="pm"]') ??
        this.doc.querySelector('button[aria-label="pm"]');

      if (amBtn) {
        this.renderer.setAttribute(amBtn, 'aria-label', 'A M');
        this.renderer.setAttribute(amBtn, 'title', 'A M');
      }

      if (pmBtn) {
        this.renderer.setAttribute(pmBtn, 'aria-label', 'P M');
        this.renderer.setAttribute(pmBtn, 'title', 'P M');
      }
    }, 0);
  }
}
